// 获取作者文章
export const GETAUTHORNEWS = 'get-author-news'

// 获取作者视频
export const GETAUTHORVIDEO = 'get-author-video'

// 获取作者文章
export const GETAUTHORCOLLECT = 'get-author-collect'

// 获取作者关注
export const GETCOLLECTAUTHOR = 'get-collect-author'

// 获取作者个人成就
export const GETAUTHORACHIEVE = 'get-author-achieve'

// 获取作者列表
export const GETAUTHOR = 'get-author'

// 获取专栏作者信息
export const GETAUTHORINFO = 'get-author-info'
